// ===========================================
// WHAT THE NUMBERS SAY — computed bullets, never generated
// ===========================================
// Three to six observations assembled in lib/pnlAnalysis from real deltas:
// the biggest margin mover, the deduction trend, the fastest-growing channel,
// concentration, and a cash note from A/R aging. Each is a template sentence
// filled with the account's own figures and rendered only when its inputs
// exist — no LLM, no speculation, and a provenance line that says so.

import type { PnlAnalysis } from '../../lib/pnlAnalysis';

export default function InsightsPanel({ a }: { a: PnlAnalysis }) {
  return (
    <div className="card p-5">
      <h2 className="font-semibold text-slate-900">What the numbers say</h2>
      {a.insights.length > 0 ? (
        <ul className="mt-3 space-y-2">
          {a.insights.map((text, i) => (
            <li key={i} className="flex gap-2.5 text-sm text-slate-700">
              <span className="text-slate-300 select-none" aria-hidden>·</span>
              <span>{text}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="mt-2 text-sm text-slate-500">
          Not enough recorded months to read a trend yet — these observations appear once a second month of
          orders lands.
        </p>
      )}
      <p className="text-[11px] text-slate-400 mt-3 pt-3 border-t border-slate-100">
        Computed from the orders, deductions and invoices recorded in Mise — template sentences filled with your
        numbers, nothing estimated or generated.
      </p>
    </div>
  );
}
